
<div class="modal fade" id="scheduleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">

            <div class="modal-header">
                <h6 class="modal-title">Enter Schedule</h6>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

                <div class="container-fluid">
                    <ul class="text-danger" *ngIf="!formState.isValid()">
                        <li *ngIf="formState.loc.invalid">{{formState.loc.errorMessage}}</li>
                        <li *ngIf="formState.commodity.invalid">{{formState.commodity.errorMessage}}</li>
                        <li *ngIf="formState.scheduleBeginDate.invalid">{{formState.scheduleBeginDate.errorMessage}}</li>
                        <li *ngIf="formState.scheduleEndDate.invalid">{{formState.scheduleEndDate.errorMessage}}</li>
                        <li *ngIf="formState.location.invalid">{{formState.location.errorMessage}}</li>
                    </ul>

                    <form #form="ngForm">

                        <div class="row g-2 mb-2">
                            <div class="col-sm-6">
                                <div class="row g-2">
                                    <div class="col-4">
                                        <label for="locCode" class="form-label">Loc</label> <div class="d-inline p-1 align-middle text-danger fw-bold">*</div>
                                        <input type="text" class="form-control form-control-sm" id="locCode" name="locCode" disabled [(ngModel)]="schedule.locCode" *ngIf="!isLocGroup" />
                                        <select id="locSelect" name="locSelect" class="form-select form-select-sm" [class.border-danger]="formState.loc.invalid"
                                                [(ngModel)]="locCode" [ngModelOptions]="{standalone: true}" *ngIf="isLocGroup">
                                            <option value=""></option>
                                            <option *ngFor="let item of locList" value="{{item.value}}">{{item.text}}</option>
                                        </select>
                                    </div>
                                    <div class="col-4">
                                        <label for="startDate" class="form-label">Start Date</label> <div class="d-inline p-1 align-middle text-danger fw-bold">*</div>
                                        <input type="date" class="form-control form-control-sm" id="startDate" name="startDate" [class.border-danger]="formState.scheduleBeginDate.invalid" [(ngModel)]="scheduleBeginDate" />
                                    </div>
                                    <div class="col-4">
                                        <label for="endDate" class="form-label">End Date</label> <div class="d-inline p-1 align-middle text-danger fw-bold">*</div>
                                        <input type="date" class="form-control form-control-sm" id="endDate" name="endDate" [class.border-danger]="formState.scheduleEndDate.invalid" [(ngModel)]="scheduleEndDate" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="row g-2">
                                    <div class="col-6">
                                        <label for="commodity" class="form-label">Commodity</label> <div class="d-inline p-1 align-middle text-danger fw-bold">*</div>
                                        <select id="commodity" name="commodity" class="form-select form-select-sm" [class.border-danger]="formState.commodity.invalid" [(ngModel)]="commodityCode">
                                            <option value=""></option>
                                            <option *ngFor="let item of commodityList" value="{{item.value}}">{{item.text}}</option>
                                        </select>
                                    </div>
                                    <div class="col-6">
                                        <label for="altCommodity" class="form-label">Alternate Commodity</label>
                                        <input type="text" class="form-control form-control-sm" id="altCommodity" name="altCommodity" [class.border-danger]="formState.commodity.invalid" [(ngModel)]="alternateCommodity" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row g-2 mb-2">
                            <div class="col-sm-5">
                                <label for="customer" class="form-label">Customer</label>
                                <input type="text" class="form-control form-control-sm" id="customer" name="customer" disabled value="{{schedule.customer.customerName}}" />
                            </div>
                        </div>

                        <div class="row mb-1" *ngIf="schedule.scheduleType == 'M'">
                            <div #locationSearchDropdown class="col-12">
                                <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" (click)="toggleLocationSearch()">
                                    Select {{locationTypeName}}
                                </button>
                                <div class="d-inline p-1 align-middle text-danger fw-bold">*</div>
                                <div *ngIf="showLocationSearch">
                                    <div class="dropdown-search table-responsive border rounded shadow px-1">
                                        <table class="table table-sm table-borderless table-hover scrollable">
                                            <thead>
                                                <tr [formGroup]="locationSearchForm">
                                                    <th>
                                                        {{locationTypeName}}
                                                        <input type="text" class="form-control form-control-sm" formControlName="locationName" />
                                                    </th>
                                                    <th>
                                                        City
                                                        <input type="text" class="form-control form-control-sm" formControlName="city" />
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of locationList; let i = index"
                                                    (click)="selectLocation(item)"
                                                    [class.table-active]="i === locationHighlightIndex">
                                                    <td>{{item.locationName}}</td>
                                                    <td>{{item.city}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row g-1 mb-2">
                            <div class="col-sm-5">
                                <label for="location" class="form-label" *ngIf="schedule.scheduleType == 'C'">{{locationTypeName}}</label>
                                <input type="text" class="form-control form-control-sm" id="location" name="location" placeholder="{{locationTypeName}}" disabled value="{{schedule.location.locationName}}" [class.border-danger]="formState.location.invalid" />
                            </div>
                            <div class="col-sm-3">
                                <label for="customer" class="form-label" *ngIf="schedule.scheduleType == 'C'">City</label>
                                <input type="text" class="form-control form-control-sm" id="locationCity" name="locationCity" placeholder="City" disabled value="{{schedule.location.city}}" />
                            </div>
                        </div>

                        <div class="row g-2 mb-2">
                            <div class="col-md-6">
                                <div class="row g-2">
                                    <div class="col-4">
                                        <label class="col-form-label-sm">Loads</label> 
                                            <input type="number" class="form-control form-control-sm" id="loads" [min]="0"
                                            (keydown)="preventNegativeKey($event)" (input)="preventNegative($event)"
                                            name="loads" [(ngModel)]="schedule.loads" [class.border-danger]="schedule.loads < 0" />
                                    </div>
                                    <div class="col-4">
                                        <label class="col-form-label-sm">Dispatched</label>
                                        <input type="text" class="form-control form-control-sm" id="dispatchLoads" name="dispatchLoads" disabled [(ngModel)]="schedule.dispatchedLoads" />
                                    </div>
                                    <div class="col-4">
                                        <label class="col-form-label-sm">{{loadType}} #</label>
                                        <input type="text" class="form-control form-control-sm" id="loadNumber" name="loadNumber" [(ngModel)]="schedule.loadNumber" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-3" *ngIf="isMobile">
                            <div style="display: flex; align-items: center;">
                                <label class="col-form-label-sm" style="margin-right: 10px;">Notes</label>
                                <ng-container>
                                    <div *ngIf="!isShowNotes" (click)="showHideNotes()">
                                        <svg enable-background="new 0 0 32 32" height="16px" version="1.1" viewBox="0 0 32 32" width="16px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                                            <g id="background"><rect fill="none" height="32" width="32" /></g>
                                            <g id="arrow_x5F_down"><polygon points="2.002,10 16.001,24 30.002,10" /></g>
                                        </svg>
                                    </div>
                                    <div *ngIf="isShowNotes" (click)="showHideNotes()">
                                        <svg enable-background="new 0 0 32 32" width="16px" height="16px" version="1.1" viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                                            <g id="backbord"><rect fill="none" height="32" width="32" /></g>
                                            <g id="arrow_x5F_up"><polygon points="30,22 16.001,8 2.001,22" /></g>
                                        </svg>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <ng-container *ngIf="!isMobile || isShowNotes">
                            <div class="row g-2 mb-3">
                                <div class="col-sm-4">
                                    <label class="col-form-label-sm">{{loadType}} Notes:</label>
                                    <textarea class="form-control form-control-sm" id="loadNotes" name="loadNotes" rows="5" [(ngModel)]="schedule.loadNotes"></textarea>
                                </div>
                                <div class="col-sm-4">
                                    <label class="col-form-label-sm">Location Notes:</label>
                                    <textarea class="form-control form-control-sm" id="locationNotes" name="locationNotes" rows="5" [(ngModel)]="schedule.locationNotes"></textarea>
                                </div>
                                <div class="col-sm-4">
                                    <label class="col-form-label-sm">Internal Notes:</label>
                                    <textarea class="form-control form-control-sm" id="internalNotes" name="internalNotes" rows="5" [(ngModel)]="schedule.internalNotes"></textarea>
                                </div>
                            </div>
                        </ng-container>

                        <div class="row mb-3">
                            <label class="col-form-label-sm">Applications</label>
                            <div class="border rounded pt-2">
                                <div class="row g-2">
                                    <div class="col-sm-5">
                                        <div #contractSearchDropdown class="row g-2 align-items-center">
                                            <div class="col-auto">
                                                <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" (click)="getContracts()">
                                                    Select Contract
                                                </button>
                                                <div *ngIf="showContractSearch">
                                                    <div class="dropdown-search table-responsive border rounded shadow px-1" style="height: 150px;">
                                                        <table class="table table-sm table-borderless table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Contract #</th>
                                                                    <th>Begin Date</th>
                                                                    <th>End Date</th>
                                                                    <th *ngIf="!isMobile" class="text-center">Qty</th>
                                                                    <th *ngIf="!isMobile" class="text-center">Open</th>
                                                                    <th class="text-center">Loads</th>
                                                                    <th class="text-center">Open Loads</th>
                                                                    <th *ngIf="!isMobile">Cust Contract</th>
                                                                    <th *ngIf="!isMobile">Cust</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let contract of contractList; let i = index"
                                                                    (click)="selectContract(contract)"
                                                                    [class.table-active]="i === contractHighlightIndex">
                                                                    <td>{{contract.contractNumber}}</td>
                                                                    <td>{{contract.periodBeginDate}}</td>
                                                                    <td>{{contract.periodEndDate}}</td>
                                                                    <td *ngIf="!isMobile" [ngClass]="!isMobile? 'text-end' : 'text-center'">{{contract.quantity}}</td>
                                                                    <td *ngIf="!isMobile" [ngClass]="!isMobile? 'text-end' : 'text-center'">{{contract.openQuantity}}</td>
                                                                    <td [ngClass]="!isMobile? 'text-end' : 'text-center'">{{contract.loads}}</td>
                                                                    <td [ngClass]="!isMobile? 'text-end' : 'text-center'">{{contract.openLoads}}</td>
                                                                    <td *ngIf="!isMobile">{{contract.customerContract}}</td>
                                                                    <td *ngIf="!isMobile">{{contract.customerCode}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-auto">
                                                <input type="text" id="contractNumber" name="contractNumber" class="form-control form-control-sm" disabled [(ngModel)]="selectedContract.contractNumber" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="row g-2 align-items-center">
                                            <div class="col-auto">
                                                <label class="col-form-label-sm">Loads:</label>
                                            </div>
                                            <div class="col-auto">
                                                <input type="number" id="contractLoads" name="contractLoads" class="form-control form-control-sm" style="width: 80px;" [(ngModel)]="selectedContract.loads" />
                                            </div>
                                            <div class="col-auto">
                                                <button type="button" class="btn btn-sm btn-secondary" (click)="applyContract()">Apply</button>
                                            </div>
                                            <div class="col-auto text-danger">
                                                {{contractLoadsError}}
                                            </div>
                                        </div>
                                    </div>
                                </div>




                                <div>
                                    <table class="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>Contract #</th>
                                                <th>Begin Date</th>
                                                <th>End Date</th>
                                                <th>Loads</th>
                                                <th> </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let contract of schedule.contracts; index as i">
                                                <td>{{contract.contractNumber}}</td>
                                                <td>{{contract.periodBeginDate}}</td>
                                                <td>{{contract.periodEndDate}}</td>
                                                <td>{{contract.loadsDisplay}}</td>
                                                <td class="text-end align-middle"><a href="#" (click)="removeContract(i)"><i class="fa-solid fa-trash-can fa-lg"></i></a></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>

            <div class="modal-footer">
                <div class="d-block w-100">
                    <button type="button" class="btn btn-sm btn-danger float-start" (click)="deleteSchedule()" *ngIf="!isNew && formStatus == FormStatus.Normal">Delete Schedule</button>
                    <div class="float-end" *ngIf="formStatus == FormStatus.Delete || formStatus == FormStatus.Deleting">
                        <button type="button" class="btn btn-sm btn-danger me-2" (click)="confirmDelete()" *ngIf="formStatus == FormStatus.Delete">Confirm Delete</button>
                        <button type="button" class="btn btn-sm btn-danger me-2" disabled *ngIf="formStatus == FormStatus.Deleting">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            <span>Deleting...</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-secondary" (click)="cancelDelete()" [disabled]="formStatus == FormStatus.Deleting">Cancel Delete</button>
                    </div>
                    <div class="float-end" *ngIf="formStatus == FormStatus.Normal || formStatus == FormStatus.Saving">
                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 80px;" (click)="onSaveClick()" *ngIf="formStatus == FormStatus.Normal" title="Ctrl+S">Save</button>
                        <button type="button" class="btn btn-sm btn-primary me-2" disabled *ngIf="formStatus == FormStatus.Saving">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            <span>Saving...</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-secondary" style="width: 80px;" data-bs-dismiss="modal" [disabled]="formStatus == FormStatus.Saving" title="Esc">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>